<script setup lang="ts">
import { useAddressStore } from '@/modules/shared/stores/address-store'
import { VTaxIdField, VTextField } from '@/modules/shared/components'
import VSelectLocal from '../../../components/v-select.vue'
import AddressForm from '../../../components/address-form.vue'

const props = defineProps<{
  form: any
  v$: any
  legalStructureOptions: { label: string; value: string }[]
  currencyOptions: { label: string; value: string }[]
}>()

const addressStore = useAddressStore()

defineExpose({
  isValid: async () => {
    const fields = ['name', 'legal_name', 'tax_id']
    const results = await Promise.all(fields.filter((f) => props.v$[f]).map((f) => props.v$[f].$validate()))
    return results.every(Boolean)
  },
})
</script>

<template>
  <div class="space-y-6">
    <div class="space-y-4">
      <VTextField
        v-model="form.legal_name"
        label="Legal Name"
        placeholder="Acme Corporation"
        property="legal_name"
        :v$="v$"
      />
      <VTextField v-model="form.name" label="Fund Name" placeholder="Acme" property="name" :v$="v$" />
    </div>

    <div class="my-8 h-px bg-gray-100"></div>

    <div class="space-y-4">
      <VSelectLocal
        v-model="form.type"
        label="Legal Structure"
        :options="legalStructureOptions"
        property="type"
        :v$="v$"
      />
      <VSelectLocal
        v-model="form.state_of_incorporation"
        label="State of Incorporation"
        :options="addressStore.stateOptions"
        property="state_of_incorporation"
        :v$="v$"
      />
      <VTaxIdField v-model="form.tax_id" label="EIN" format="ein" property="tax_id" :v$="v$" />
      <VTextField v-model="form.date" type="date" label="Date Established" property="date" :v$="v$" />
    </div>

    <div class="my-8 h-px bg-gray-100"></div>

    <VSelectLocal
      v-if="!form.is_venture360_the_administrator"
      v-model="form.currency"
      label="Currency"
      :options="currencyOptions"
      property="currency"
      :v$="v$"
    />

    <div v-if="!form.is_venture360_the_administrator" class="my-8 h-px bg-gray-100"></div>

    <AddressForm :modelValue="form" :v$="v$" />
  </div>
</template>
